import React, { useState,useRef,useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { configData } from "../config";
import "./classes/Sales.css";
import "./classes/Main.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCheck, faXmark, faPrint } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from 'react-helmet';
import { useReactToPrint } from "react-to-print";
import { toWords } from 'number-to-words';

const Estimate = () => {

  const app_url = configData.APP_URL;

  const [invoiceNumber, setInvoiceNumber] = useState(null);
// const fetchInvoiceNumber = async () => {
//   try {
//     const res = await fetch(app_url + "salesapi/get-invoice-number");
//     const data = await res.json();

//     if (data.success) {
//       setInvoiceNumber(data.invoice_number);
//       return data.invoice_number;
//     }
//   } catch (error) {
//     console.error("Error fetching invoice number:", error);
//   }
// };
// useEffect(() => {
//   fetchInvoiceNumber();
// }, []);
  const [companyDetail, setCompanyDetail] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [customerSearch, setCustomerSearch] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [qty, setQty] = useState(1);
  const [unitCost, setUnitCost] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lines, setLines] = useState([]);
  const [customerType, setCustomerType] = useState("retail");
  const [cashReceived, setCashReceived] = useState("");
  const [open, setOpen] = useState(false);
 // const inputRef = useRef(null);
  const inputSearchRef = useRef(null);
useEffect(() => {
  if (companyDetail && inputSearchRef.current) {
    setTimeout(() => {
      inputSearchRef.current.focus();
    }, 150);
  }
}, [companyDetail]);
  // useEffect(() => {
  //   if (searchValue === "") {
  //     inputSearchRef.current?.focus();
  //   }
  // }, [searchValue]);
  const [printType, setPrintType] = useState("receipt-58mm");
  const [showPrintPopup, setShowPrintPopup] = useState(false);
  const [invoiceNumberForPrint, setInvoiceNumberForPrint] = useState(null);
  const [invoiceEstimateForPrint, setEstimateNumberForPrint] = useState(null);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
      contentRef: contentRef,
      // documentTitle: String(invoiceNumberForPrint),
      documentTitle: "Quotation",
      onAfterPrint: () => {
          setLines([]);
          setCashReceived("");
          setSelectedCustomer(null);
          setCustomerSearch("");
          setSelectedProduct(null);
          setSearchValue("");
          setQty(1);
          setUnitCost(0);

          // fetchInvoiceNumber();
        setTimeout(() => {
          inputSearchRef.current?.focus();
        }, 150);
      },
    });

  const onPrintClick = (size) => {
    if (lines.length === 0) return;
    setPrintType(size);
    setShowPrintPopup(false);
    setTimeout(() => {
      handlePrint();
    }, 100);
  };

  const canSaveOrPrint = () => {
    if (lines.length === 0) return false;
    return true;
  };

useEffect(() => {
  if (!customerSearch.trim()) {
    setCustomerOptions([]);
    return;
  }

  const timer = setTimeout(async () => {
    try {
      const res = await fetch(
        app_url + "salesapi/getcustomerlist?query=" + customerSearch
      );
      const data = await res.json();
      setCustomerOptions(data || []);
    } catch (err) {
      console.error("Customer fetch error", err);
    }
  }, 400);

  return () => clearTimeout(timer);
}, [customerSearch]);
  useEffect(() => {
    const fetchData = async () => {
      if (searchValue.trim() === '') {
        setOptions([]); // Clear options if search is empty
        return;
      }
      try {
        const response = await fetch(app_url+'items/getproductlist?query='+searchValue+'&type='+customerType);
        const data = await response.json();
        setOptions(data); 
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const handler = setTimeout(() => {
      fetchData();
    }, 500); // Debounce for 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue,customerType]);
const handleCustomerTypeChange = (e) => {
  setCustomerType(e.target.value);
  setOptions([]); // reset prices 
};
      
const handleKeyDown = async (e) => {
  if (e.key !== "Enter") return;

  e.preventDefault();

  if (selectedProduct) {
    addLineFromProduct(selectedProduct);
    return;
  }

  if (!searchValue.trim()) return;

  try {
    const res = await fetch(app_url+'items/getproductlist?query='+searchValue);
    const data = await res.json();

    if (data?.length === 1) {
      addLineFromProduct(data[0]);
    }
  } catch (err) {
    console.error(err);
  }
};

const focusProductInput = () => {
  setTimeout(() => {
    inputSearchRef.current?.focus();
  }, 50);
};

const addLineFromProduct = (product) => {
  setLines(prevLines => {
    const price = unitCost || product.unitCost;
    const quantity = Number(qty);
    const hsn_code = product.hsn_code;
    const unit = product.unit;

    const lineSubTotal = quantity * price;

    const existingLine = prevLines.find(
      line => line.barcode === product.barcode
    );

    if (existingLine) {
      return prevLines.map(line => {
        if (line.barcode !== product.barcode) return line;

        const newQty = line.qty + quantity;
        const newSub = newQty * price;

        return {
          ...line,
          qty: newQty,
          hsn_code: hsn_code,
          unit: unit,
          lineSubTotal: newSub,
          lineTotal: newSub
        };
      });
    }

    return [
      ...prevLines,
      {
        id: product.id,
        product: product.name,
        barcode: product.barcode,
        hsn_code: product.hsn_code,
        unit: product.unit,
        qty: quantity,
        unitCost: price,

        lineSubTotal,
        lineTotal: lineSubTotal
      }
    ];
  });

  setSelectedProduct(null);
  setSearchValue("");
  setQty(1);
  setUnitCost(0);
  focusProductInput();
};

const updateLine = (id, field, value) => {
  setLines(prev =>
    prev.map(line => {
      if (line.id !== id) return line;

      const updated = { ...line, [field]: Number(value) };

      const sub = updated.qty * updated.unitCost;

      return {
        ...updated,
        lineSubTotal: sub,
        lineTotal: sub
      };
    })
  );
};

  const removeLine = (id) => {
    setLines(prev => prev.filter(line => line.id !== id));

    setTimeout(() => {
      inputSearchRef.current?.focus();
    }, 0);
  };
  
const subTotal = lines.reduce((s, l) => s + l.lineSubTotal, 0);

const grandTotal = parseFloat((subTotal).toFixed(2));

const roundedTotal = Math.round(grandTotal); 

// const roundOff = Math.round((roundedTotal - grandTotal) * 100) / 100;

const handleSubmit = async () => {
  if (isSubmitting) return;
  if (lines.length === 0) {
    alert("Add at least one product");
    return;
  }
  setIsSubmitting(true);
  const payload = {
    total_amount: Number(grandTotal.toFixed(2)),
    sub_total: Number(subTotal.toFixed(2)),

    customer_type: customerType,
    customer_id: selectedCustomer?.id || null,

    items: lines.map(line => ({
      item_id: line.id,
      item_name:line.product,
      barcode:line.barcode,
      quantity:String(line.qty),
      price: line.unitCost,
      sub_total: line.lineSubTotal,
      total: line.lineTotal,
    }))
  };
console.log(payload);
  try {
    const res = await fetch(
      app_url + "estimate-api/save-estimate",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      }
    );

    const data = await res.json();

    if (data.success) {
      alert("Order saved successfully");
        // const currentInvoiceNumber = data.invoice_number;
        const currentEstimateNumber = data.estimate_number;
        setSelectedProduct(null);
        setSearchValue("");
        setQty(1);
        setUnitCost(0);
        setShowPrintPopup(true);
        setEstimateNumberForPrint(currentEstimateNumber);
        // setInvoiceNumberForPrint(currentInvoiceNumber);
        // await fetchInvoiceNumber();

        setTimeout(() => {
          inputSearchRef.current?.focus();
        }, 100);
    } else {
      alert("Failed to save order");
    }
  } catch (err) {
    console.error(err);
  } finally{
    setIsSubmitting(false);
  }
};

  const companydetails = async () => {
    try {
      const res = await fetch(app_url + "salesapi/showcom");
      const data = await res.json();
      if (data.company) {
        setCompanyDetail(data.company);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    companydetails();
  }, []);

  if (!companyDetail) return;

  const now = new Date();

  // const quotationDate = now.toLocaleDateString();
  const quotationDate = now.toLocaleDateString("en-GB");
  const quotationTime = now.toLocaleTimeString();

 const handleCancel = async () => {
  setLines([]);
  setCashReceived("");
  setSelectedCustomer(null);
  setCustomerSearch("");
  setSelectedProduct(null);
  setSearchValue("");
  setQty(1);
  setUnitCost(0);

  setTimeout(() => {
    inputSearchRef.current?.focus();
  }, 100);
};

  function capitalizeWords(str) {
    return str
      .split(" ")
      .map(word => (word.toLowerCase() === "and" ? "and" : word.charAt(0).toUpperCase() + word.slice(1)))
      .join(" ");
  }

  // Usage
  const totalInWords = toWords(Math.floor(roundedTotal)); // integer part
  const decimalPart = Math.round((roundedTotal - Math.floor(roundedTotal)) * 100);

  let totalInWordsWithDecimals = decimalPart
    ? `${totalInWords} rupees and ${toWords(decimalPart)} paise`
    : `${totalInWords} rupees`;

  totalInWordsWithDecimals = capitalizeWords(totalInWordsWithDecimals);

    const getRowConfig = (type) => {
        switch (type) {
            case "invoice-a4":
            return { FIRST: 24, LAST: 18 };
            case "receipt-152mm":
            return { FIRST: 12, LAST: 5 };
            default:
            return { FIRST: 24, LAST: 18 };
        }
    };

  const { FIRST: MAX_ROWS_FIRST, LAST: MAX_ROWS_LAST } = getRowConfig(printType || "invoice-a4");
                    // const lines = orderItems[selectedInvoice.transaction_id] || [];

  const paginateItems = (items) => {
    const pages = [];
    let remaining = [...items];

    while (remaining.length > 0) {
        if (remaining.length > MAX_ROWS_FIRST) {
        pages.push(remaining.slice(0, MAX_ROWS_FIRST));
        remaining = remaining.slice(MAX_ROWS_FIRST);
        } else {
        if (remaining.length <= MAX_ROWS_LAST) {
            pages.push(remaining);
        } else {
            // Distribute so last page is small (2–3 items)
            const lastPageCount = Math.min(3, remaining.length);
            const secondLastCount = remaining.length - lastPageCount;

            pages.push(remaining.slice(0, secondLastCount)); // e.g. 5
            pages.push(remaining.slice(secondLastCount));    // e.g. 2–3
        }
        break;
        }
    }

    return pages;
  };

  const pages = paginateItems(lines);
  let runningIndex = 0;

  return (
    <div className="purchase-order-page">
         <Helmet>
            <title>Estimate</title>
         </Helmet>
    <div className="create-purchase-order-container">
    <div className="po-modal">

      <div className="po-body">
        <div className="row po-summary-row">
        <div className="main-total">
          Total: ₹{grandTotal.toFixed(2)}
        </div>
        </div>

        <div className="po-options-row">
          <div className="po-option">
            <label htmlFor="customer-type">Customer Type</label>
            <select id="customer-type" value={customerType} onChange={handleCustomerTypeChange}>
              <option value="retail">Retail</option>
              <option value="wholesale">Wholesale</option>
            </select>
          </div>
          <div className="po-option" style={{ minWidth: 260 }}>
            <label>Customer</label>

            <Autocomplete
              className="customer-search"
              options={customerOptions}
              value={selectedCustomer}
              getOptionLabel={(option) => option.name}
              filterOptions={(x) => x}
              onChange={(e, value) => setSelectedCustomer(value)}
              inputValue={customerSearch}
              onInputChange={(e, value) => setCustomerSearch(value)}
              renderOption={(props, option) => (
                <li {...props} style={{ display: "flex", flexDirection: "column", padding: "6px 10px" }}>
                  {/* {option.name} */}
                  <span style={{ fontWeight: 500, fontSize: "14px", color: "#333" }}>
                    {option.name}
                  </span>
                  <span style={{ fontSize: "12px", color: "#666", marginTop: "2px" }}>
                    {option.phone_number && <span>Ph: {option.phone_number} </span>}
                    {(option.phone_number && option.gst_number) && <> | </>}
                    {option.gst_number && <span>GST: {option.gst_number}</span>}
                  </span>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select customer"
                  size="small"
                />
              )}
            />
          </div>
        </div>

        <div className="add-line">
          <div>
            <p>Product</p>
            <div className="pos-autocomplete-search">
            <Autocomplete 
              disablePortal   
              className="pos-autocomplete"          
              options={options}
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              getOptionLabel={(option) => option.name}
              value={selectedProduct}
              inputValue={searchValue}
              onInputChange={(e, value) => setSearchValue(value)}
              // onChange={(e, value) => {
              //   if (!value) return;
              //   setSelectedProduct(value);
              //   setUnitCost(value.unitCost);
              // }}
              onChange={(e, value) => {
                if (!value) return;

                setSelectedProduct(value);
                setUnitCost(value.unitCost);

                setOptions([]); 
                setSearchValue(""); 
                
              }}
              renderOption={(props, option) => (
                <li {...props}>
                  <strong>{option.name}</strong>&nbsp;&nbsp;-&nbsp;
                  <span style={{ marginLeft: "10px", color: "#666" }}>
                    ₹{option.unitCost}
                  </span>
                  {/* <span style={{ marginLeft: "10px", color: "#666" }}>
                    (Stock: {option.quantity_stock})
                  </span> */}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputRef={inputSearchRef}
                  placeholder="Search or scan barcode"
                  // onKeyDown={handleKeyDown}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      // If the dropdown is visible, let MUI handle the selection.
                      // Once the dropdown closes (after selection), this block is skipped.
                      if (open && options.length > 0) {
                        return; 
                      }
                    }

                    // Now, if the dropdown is closed, this will run on the next Enter press
                    handleKeyDown(e);
                  }}
                  InputProps={{
                    ...params.InputProps,
                      endAdornment: (
                      <div className="pos-end-adornment">
                        {params.InputProps.endAdornment}
                      </div>
                    ),
                  }}
                />
              )}
            />
            </div>
          </div>
          <div>
            <p>Qty</p>
            <input
              type="number"
              min="1"
              value={qty}
              onChange={e => setQty(e.target.value)}
              onWheel={(e) => {
                e.preventDefault();
                e.currentTarget.blur(); 
              }}
            />
          </div>
          <div>
            <p>Unit Cost (₹)</p>
            <input
              type="number"
              step="0.01"
              value={unitCost}
              onChange={e => setUnitCost(e.target.value)}
              onWheel={(e) => {
                e.preventDefault();
                e.currentTarget.blur(); 
              }}
            />
          </div>
          <button onClick={() => selectedProduct && addLineFromProduct(selectedProduct)} className="add-line-button" style={{cursor:"pointer"}}>
            <FontAwesomeIcon icon={faPlus} /> Add Line
          </button>

        </div>
        
        <div className="purchase-table">
          <div className="purchase-table-desktop">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Unit Cost</th>
                  <th>Line Total</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {lines.length > 0 ? (<>
                {lines.map((line, index) => (
                  <tr key={line.id}>
                    <td>{index + 1}</td>
                    <td>{line.product}</td>
                    <td>
                      <input
                        type="number"
                        value={line.qty}
                        onChange={e => updateLine(line.id, "qty", e.target.value)}
                        onWheel={(e) => {
                          e.preventDefault();
                          e.currentTarget.blur(); 
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={line.unitCost}
                        onChange={e =>
                          updateLine(line.id, "unitCost", e.target.value)
                        }
                        onWheel={(e) => {
                          e.preventDefault();
                          e.currentTarget.blur(); 
                        }}
                      />
                    </td>
                    <td>₹{line.lineTotal.toFixed(2)}</td>
                    <td><FontAwesomeIcon style={{color:"red",cursor:"pointer"}} icon={faXmark} onClick={() => removeLine(line.id)}/>
                    </td>
                  </tr>
                ))}
                </>):(<tr><td colSpan={6}>No items yet</td></tr>)}
              </tbody>
              <tfoot className="po-table-footer">

              <tr className="po-footer-grand">
                <td colSpan={4} className="po-footer-label">Grand Total</td>
                <td className="po-footer-value">₹{grandTotal.toFixed(2)}</td>
                <td></td>
              </tr>
            </tfoot>
            </table>
          </div>
          <div className="purchase-cards-mobile">
            {lines.length > 0 ? (
              <>
                {lines.map((line, index) => (
                  <div key={line.id} className="po-line-card">
                    <div className="po-line-card-header">
                      <span className="po-line-card-product">{line.product}</span>
                      <button type="button" className="po-line-card-remove" onClick={() => removeLine(line.id)} aria-label="Remove">
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                    <div className="po-line-card-body">
                      <div className="po-line-card-field">
                        <label>Qty</label>
                        <input
                          type="number"
                          min="1"
                          value={line.qty}
                          onChange={e => updateLine(line.id, "qty", e.target.value)}
                          onWheel={(e) => {
                            e.preventDefault();
                            e.currentTarget.blur(); 
                          }}
                        />
                      </div>
                      <div className="po-line-card-field">
                        <label>Unit Cost (₹)</label>
                        <input
                          type="number"
                          step="0.01"
                          value={line.unitCost}
                          onChange={e => updateLine(line.id, "unitCost", e.target.value)}
                          onWheel={(e) => {
                            e.preventDefault();
                            e.currentTarget.blur(); 
                          }}
                        />
                      </div>
                      <div className="po-line-card-total">
                        ₹{line.lineTotal.toFixed(2)}
                      </div>
                    </div>
                  </div>
                ))}
                <div className="po-cards-summary">

                  <div className="po-summary-row po-summary-total">
                    <span>Total</span>
                    <span>₹{grandTotal.toFixed(2)}</span>
                  </div>
                </div>
              </>
            ) : (
              <div className="po-cards-empty">No items yet</div>
            )}
          </div>
        </div>

        <div className="billing-actions" style={{textAlign:"right"}}>
          <a className="cancel" onClick={handleCancel} style={{cursor:"pointer"}}>Cancel</a>&nbsp;
          {/* <button className="save" disabled={isSubmitting} style={{ cursor: "pointer" }} onClick={handleSubmit} >
            <FontAwesomeIcon icon={faCheck} />  {isSubmitting ? "Saving..." : "Save Order"}</button>&nbsp; */}
          <button
            className="save save-print"
            disabled={isSubmitting}
            style={{ cursor: "pointer", backgroundColor: "#E03F5B" }}
            onClick={() => {
              canSaveOrPrint();
              handleSubmit();
            }}
          >
            <FontAwesomeIcon icon={faPrint} />  Save & Print
          </button>
        </div>
      </div>
    </div>
    </div>

    {showPrintPopup && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3 style={{margin: "2px 0px", textAlign: "center"}}>Select Print Size</h3>

          <button onClick={() => onPrintClick("receipt-58mm")}>
            Print 2"
          </button>

          {/* <button onClick={() => onPrintClick("receipt-152mm")}>
            Print 6"
          </button> */}

          <button onClick={() => onPrintClick("invoice-a4")}>
            Print A4
          </button>

          <button onClick={() => onPrintClick("invoice-a4")}>
            Print A5
          </button>

          <button onClick={() => setShowPrintPopup(false)}>
            Cancel
          </button>
        </div>
      </div>
    )}

    <div ref={contentRef} className={`printContent ${printType}`}>
                <>
                    <div className="receipt receipt-58mm">
                        <h2 className="center bold" style={{marginBottom: "0"}}>{companyDetail.company_name}</h2>
                        <div className="center small">
                            <span>{companyDetail.company_address}</span><br />
                            <span>GST No.: {companyDetail.gst_number}</span><br />
                            <span>Contact: {companyDetail.phone}</span>
                        </div>
                        <div className="dash-line"></div>    
                        <h2 className="center bold">QUOTATION</h2>

                        <div className="center small">
                            <span>
                                Quote #: {invoiceEstimateForPrint}
                            </span>
                            <br />
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span>{quotationDate}</span>
                                <span>{quotationTime}</span>
                            </div>
                        </div>

                        <div className="dash-line"></div>

                        <div className="items-header">
                            <span>Qty</span>
                            <span>Item</span>
                            <span className="right">Price</span>
                        </div>

                        <div className="dash-line"></div>

                        {lines.map(line => (
                          <div key={line.id} className="item-row">
                            <span style={{textAlign: "center", width: "21px"}}>{line.qty}</span>
                            <span className="item-name">{line.product}</span>
                            <span className="right">₹{line.lineTotal.toFixed(2)}</span>
                          </div>
                        ))}

                        <div className="dash-line"></div>

                        <div className="dash-line"></div>
                        <div className="row total bold">
                            <span>TOTAL:</span>
                            <span>₹{grandTotal.toFixed(2)}</span>
                        </div>
                        <div className="dash-line"></div>
                        <div className="dash-line"></div>

                        <div className="center thanks">*** THANK YOU ***</div>

                    </div>


            {/* 152mm receipt & A4 invoice */}
            {/* <div className={printType === "invoice-a4" ? "invoice-a4" : "receipt-152mm"}> */}
{pages.map((pageItems, pageIndex) => {
    const isLastPage = pageIndex === pages.length - 1;

    // const FOOTER_RESERVED_ROWS = 8; // adjust based on your footer height

    // const maxRows = isLastPage
    // ? MAX_ROWS_FIRST - FOOTER_RESERVED_ROWS
    // : MAX_ROWS_FIRST;
    const maxRows = isLastPage ? MAX_ROWS_LAST : MAX_ROWS_FIRST;
    const emptyRows = Math.max(0, maxRows - pageItems.length);

    const startIndex = runningIndex;
    runningIndex += pageItems.length;

    return (
        <div
            key={pageIndex}
            className="invoice-a4"
        >
                <div style={{ fontSize: "14px", padding: "10px", textAlign: "center" }}>Quotation</div>
                <table className="invoice-table">

                  <thead>
                    {/* Company Section */}
                    <tr>
                        <td style={{ width: "60%", verticalAlign: "top" }}>
                            <table className="no-border-top no-border-left no-border-bottom" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <td style={{fontWeight: "700"}}>{companyDetail.company_name}</td>
                                    </tr>
                                    <tr>
                                        <td>{companyDetail.company_address}</td>
                                    </tr>
                                    <tr>
                                        <td>GSTIN: {companyDetail.gst_number}</td>
                                    </tr>
                                    <tr>
                                        <td>Contact: {companyDetail.phone}</td>
                                    </tr>
                                </thead>
                            </table>
                        </td>

                        <td style={{ width: "40%" }}>
                            <table className="no-border-top no-border-left no-border-right no-border-bottom" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <td>Date: {quotationDate}</td>
                                    </tr>
                                    <tr>
                                        <td>Quote #: {invoiceEstimateForPrint}</td>
                                    </tr> 
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                            </table>
                        </td>
                    </tr>

                    {/* Billing Section */}

                    <tr>
                        <td colSpan={2}>
                            <table className="no-border-bottom no-border-left no-border-right" style={{ width: "100%" }}>
                                <thead>
                                    {selectedCustomer && <>
                                    <tr><td>To</td></tr>
                                      <tr>
                                          <td>
                                            <span style={{fontWeight: "700"}}>{selectedCustomer.name && <>{selectedCustomer.name}</>}</span>
                                            <span>{selectedCustomer.address && <> {selectedCustomer.address}</>}</span>&nbsp;
                                            <span>{selectedCustomer.gst_number && <>| GSTIN: {selectedCustomer.gst_number}</>}</span>&nbsp;
                                            <span>{selectedCustomer.phone_number && <>| Contact: {selectedCustomer.phone_number}</>}</span>&nbsp;
                                            <span>{selectedCustomer.email && <>| Email ID: {selectedCustomer.email}</>}</span>
                                          </td>
                                      </tr>
                                      {/* <tr>
                                          <td>{selectedCustomer.address && <>{selectedCustomer.address}</>}</td>
                                      </tr>
                                      <tr>
                                          <td>{selectedCustomer.gst_number && <>GSTIN: {selectedCustomer.gst_number}</>}</td>
                                      </tr>
                                      <tr>
                                          <td>{selectedCustomer.phone_number && <>Contact: {selectedCustomer.phone_number}</>}</td>
                                      </tr>
                                      <tr>
                                          <td>{selectedCustomer.email && <>Email ID: {selectedCustomer.email}</>}</td>
                                      </tr> */}
                                    </>}
                                </thead>
                            </table>
                        </td>
                        {/* <td style={{ width: "40%" }}></td> */}
                    </tr>

                    {/* Items Table */}

                    <tr>
                      <td colSpan="2">
                        <table className="invoice-main-table no-border-left no-border-right no-border-bottom no-border-bottom-th" style={{ width: "100%" }}>
                            <colgroup>
                                <col style={{width: "5%"}} />
                                <col style={{width: "30%"}} />
                                <col style={{width: "13%"}} />
                                <col style={{width: "10%"}} />
                                <col style={{width: "10%"}} />
                                <col style={{width: "14%"}} />
                                <col style={{width: "18%"}} />
                            </colgroup>                        

                            <thead>
                                <tr>
                                    <th style={{fontSize: "12px"}}>Sl No.</th>
                                    <th>Description of Goods</th>
                                    <th>HSN/SAC</th>
                                    <th>Qty</th>
                                    <th>per</th>
                                    <th>Rate</th>
                                    {/* <th>Disc. %</th> */}
                                    <th>Amount</th>
                                </tr>
                            </thead>
                        </table>
                      </td>
                    </tr>
</thead>
                    <tr>
                        <td colSpan="2">
                            <table className="no-border-left no-border-right no-border-bottom invoice-main-table" style={{ width: "100%", padding: "0px" }}>
                              <colgroup>
                                <col style={{width: "5%"}} />
                                <col style={{width: "30%"}} />
                                <col style={{width: "13%"}} />
                                <col style={{width: "10%"}} />
                                <col style={{width: "10%"}} />
                                <col style={{width: "14%"}} />
                                <col style={{width: "18%"}} />
                              </colgroup> 
                            <tbody>

                                {/* {lines.map((line,idx) => ( */}
                                {pageItems.map((line, idx) => (
                                    <tr key={line.id}>
                                    {/* <td>{idx + 1}</td> */}
                                    <td>{startIndex + idx + 1}</td>
                                    <td style={{fontWeight: "700", textAlign: "left"}}>{line.product}</td>
                                    <td>{line.hsn_code && <>{line.hsn_code}</>}</td>
                                    <td>{line.qty}</td>
                                    <td>{line.unit && <>{line.unit}</>}</td>
                                    <td>₹{Number(line.unitCost || 0).toFixed(2)}</td>
                                    <td>
                                      ₹{line.lineTotal.toFixed(2)}
                                    </td>
                                    </tr>
                                ))}
                                {Array.from({ length: emptyRows }).map((_, i) => (
                                    <tr key={`empty-${i}`}>
                                        <td>&nbsp;</td>
                                        <td></td><td></td><td></td>
                                        <td></td><td></td><td></td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                        </td>
                    </tr>
                    {isLastPage && (
                      <>
                        <tfoot>                                            
                          <tr><td colSpan={2}>
                          <table className="invoice-main-table no-border-left no-border-right" style={{ width: "100%" }}>
                              <colgroup>
                                <col style={{width: "5%"}} />
                                <col style={{width: "30%"}} />
                                <col style={{width: "13%"}} />
                                <col style={{width: "10%"}} />
                                <col style={{width: "10%"}} />
                                <col style={{width: "14%"}} />
                                <col style={{width: "18%"}} />
                              </colgroup> 
                          <tr style={{ fontWeight: "bold" }}>
                              <td></td>
                              <td>Total</td>
                              <td></td><td></td><td></td><td></td>
                              <td>₹{grandTotal.toFixed(2)}</td>
                          </tr>

                                            </table>
                                            </td></tr>

                          <tr>
                              <td colSpan={2} style={{padding: "3px"}}>
                              <div>Amount Chargeable (in words)</div>
                              <div style={{fontWeight: "700"}}>{totalInWordsWithDecimals} only</div>
                              </td>
                          </tr>

                          <tr>
                              <td colSpan={2}>
                                  <table style={{ width: "100%", tableLayout: "fixed" }} className="no-border-left no-border-right">
                                      <colgroup>
                                          <col style={{ width: "50%" }} />
                                          <col style={{ width: "50%" }} />
                                      </colgroup>

                                      <tbody>
                                          <tr>
                                          <td style={{padding: "3px 10px 3px 3px"}}>
                                              <span style={{fontSize: "13px", textDecoration: "underline"}}>Declaration</span><br />
                                              <span>We declare that this quotation shows the actual price of the goods described and that all particulars are true and correct.</span>
                                          </td>
                                          {companyDetail.account_no && 
                                          <td>
                                              <div>Company's Bank Details</div>
                                              <div>Bank Name: {companyDetail.bank_name && <span style={{fontWeight: "700"}}>{companyDetail.bank_name}</span>}</div>
                                              <div>A/c No.: {companyDetail.account_no && <span style={{fontWeight: "700"}}>{companyDetail.account_no}</span>}</div>
                                              <div>Branch & IFS Code: <span style={{fontWeight: "700"}}>{companyDetail.branch && <span>{companyDetail.branch}</span>}
                                              {companyDetail.ifsc && <span> & {companyDetail.ifsc}</span>}</span></div>
                                          </td>}
                                          </tr>
                                      </tbody>
                                  </table>
                              </td>
                          </tr>

                          {/* Footer */}
                          <tr>
                              <td colSpan={2}>
                                  <table style={{ width: "100%", tableLayout: "fixed" }} className="no-border">
                                      <colgroup>
                                          <col style={{ width: "50%" }} />
                                          <col style={{ width: "50%" }} />
                                      </colgroup>

                                      <tbody>
                                          <tr>
                                          <td style={{ height: "80px" }}>
                                              Customer's Seal and Signature
                                          </td>

                                          <td style={{ textAlign: "right", height: "80px", borderLeft: "1px solid #111"}}>
                                              <div style={{display:"flex", flexDirection:"column", height:"100%"}}>
                                                  <div style={{fontWeight: "700"}}>for {companyDetail.company_name}</div>
                                                  <div style={{ marginTop: "auto" }}>Authorised Signatory</div>
                                              </div>
                                          </td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </td>
                          </tr>
                    </tfoot>
                      </>
                    )}
                </table>
            </div>)})}
        </>
    </div>
    </div>
    
  );
};

export default Estimate;